import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icon';
import {
  Container,
  ControlsButton,
  StyledFooterControls,
  StyledTradeOption
} from './Styles';

const defaultProps = {
  testId: undefined
};

const propTypes = {
  testId: PropTypes.string,
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element,
        PropTypes.number
      ]).isRequired,
      onClick: PropTypes.func,
      isCopy: PropTypes.bool,
      hide: PropTypes.bool,
      disabled: PropTypes.bool
    })
  ).isRequired
};

const KebabMenu = ({ testId, actions }) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef();

  useEffect(() => {
    const listener = document.addEventListener('mouseup', e => {
      if (!containerRef.current?.contains(e.target)) {
        setIsOpen(false);
      }
    });
    return () => {
      document.removeEventListener('mouseup', listener);
    };
  }, []);

  if (actions == null || actions.length === 0) return null;

  const handleOnClick = ({ onClick, disabled }) => event => {
    event.stopPropagation();
    event.preventDefault();
    event.persist();

    if (onClick && !disabled) {
      onClick(event);
      setIsOpen(false);
    }
  };

  const handleTogglePopup = event => {
    event.stopPropagation();
    setIsOpen(open => !open);
  };

  return (
    <Container ref={containerRef}>
      <ControlsButton
        data-testid={testId}
        isOpen={isOpen}
        onClick={handleTogglePopup}
      >
        <Icon icon="TR5-Kebab" />
      </ControlsButton>
      {isOpen && (
        <StyledFooterControls data-testid={`${testId}-dropdown`}>
          {actions.map(({ hide, label, isCopy, onClick, disabled }, index) => (
            // eslint-disable-next-line
            <React.Fragment key={index}>
              {!hide && (
                <StyledTradeOption
                  onClick={handleOnClick({ onClick, disabled })}
                  data-testid={`${testId}-option`}
                  isCopy={isCopy || false}
                  disabled={disabled}
                >
                  {label}
                </StyledTradeOption>
              )}
            </React.Fragment>
          ))}
        </StyledFooterControls>
      )}
    </Container>
  );
};

KebabMenu.propTypes = propTypes;
KebabMenu.defaultProps = defaultProps;

export default KebabMenu;
